import React from 'react';
import { IonButton, IonIcon, IonSpinner, IonText } from '@ionic/react';

type ActionIconButtonSize = 'default' | 'compact';

interface ActionIconButtonProps {
  icon: string;
  label: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
  buttonStyle?: React.CSSProperties;
  size?: ActionIconButtonSize;
  // Pass-through metadata set by data adapters; grouping/ordering is resolved by the list renderer.
  group?: number;
  order?: number;
}

const ActionIconButton: React.FC<ActionIconButtonProps> = ({ icon, label, disabled, loading, onClick, buttonStyle, size = 'default' }) => {
  const isCompact = size === 'compact';

  return (
    <IonButton
      fill="clear"
      title={label}
      disabled={disabled || loading}
      onClick={onClick}
      style={{
        paddingLeft: isCompact ? '4px' : '6px',
        paddingRight: isCompact ? '4px' : '6px',
        minHeight: isCompact ? '40px' : '52px',
        height: 'auto',
        borderRadius: isCompact ? '8px' : '12px',
        textTransform: 'none',
        ...buttonStyle,
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: isCompact ? '1px' : '2px', padding: isCompact ? '2px 0' : '4px 0' }}>
        {loading
          ? <IonSpinner name="crescent" style={{ width: isCompact ? '12px' : '18px', height: isCompact ? '12px' : '18px' }} />
          : <IonIcon icon={icon} style={{ fontSize: isCompact ? '12px' : '18px' }} />}
        {!isCompact && (
          <IonText
            style={{
              fontSize: '0.55rem',
              lineHeight: '1.1',
              maxWidth: '64px',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'center',
              whiteSpace: 'normal',
            }}
          >
            {label}
          </IonText>
        )}
      </div>
    </IonButton>
  );
};

export default ActionIconButton;
